export default function processResponse (response) {
  let isOk = response.ok;
  if (isOk && response.status !== 401 ) {
    switch(response.status)
    {
      case 401:
      break;
      default:
        return response.json();
    }
  }
  else
  {
      switch(response.status)
      {
        case 422:
          return response.json();
        default:
        break;
      }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/util/processResponse.js